export default {"src":"/planning/bridesmaid-dress/quiz/_next/static/media/error-404.16803b17.svg","height":195,"width":400};